import { render, staticRenderFns } from "./SurveyEditor.vue?vue&type=template&id=f08e0c46&scoped=true&"
import script from "./SurveyEditor.vue?vue&type=script&lang=js&"
export * from "./SurveyEditor.vue?vue&type=script&lang=js&"
import style0 from "./SurveyEditor.vue?vue&type=style&index=0&id=f08e0c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e0c46",
  null
  
)

component.options.__file = "SurveyEditor.vue"
export default component.exports